module.exports = __webpack_public_path__ + "img/Security1_JP@3x.d45c59c3.png";